"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'CPPlanAndTaskList',
      apiModule: 'kpiSet',
      searchQuery: {
        srCode: '',
        srName: '',
        startTime: '',
        endTime: ''
      }
    };
  },
  computed: {
    domData: function domData() {
      return {
        srCode: {
          label: this.$t('sfe.pattenkpi.srId'),
          valueKey: 'srCode'
        },
        srName: {
          label: this.$t('sfe.pattenkpi.srName'),
          valueKey: 'srName'
        },
        timeRange: {
          label: this.$t('common.date'),
          valueKey: 'timeRange',
          inputType: 'daterange',
          keyList: ['startTime', 'endTime']
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.cpplanandtasklist'),
          apiUrl: '/protected/cp/report/planTask/export'
        }
      };
    },
    tableDom: function tableDom() {
      var ruleDataList = this.createRuleDataList();
      return (0, _objectSpread2.default)({
        srCode: {
          label: this.$t('sfe.pattenkpi.srId')
        },
        srName: {
          label: this.$t('sfe.pattenkpi.srName')
        }
      }, ruleDataList);
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/cp/report/planTask/list'
      };
    }
  },
  methods: {
    createRuleDataList: function createRuleDataList() {
      var _this = this;
      var number9List = {};
      var combinedTypeList = ['a01PlanCount', 'a01PlanCountMix', 'a01TaskCount', 'a01TaskCountMix', 'a01PlanTime', 'a01PlanTimeMix', 'a01TaskTime', 'a01TaskTimeMix', 'a02PlanCount', 'a02PlanTime', 'a03PlanCount', 'a03TaskCount', 'a03PlanTime', 'a03TaskTime', 'a04PlanCount', 'a04TaskCount', 'a04PlanTime', 'a04TaskTime', 'a05PlanCount', 'a05TaskCount', 'a05PlanTime', 'a05TaskTime', 'a06PlanCount', 'a06TaskCount', 'a06PlanTime', 'a06TaskTime', 'a07PlanCount', 'a07TaskCount', 'a07PlanTime', 'a07TaskTime', 'a08PlanCount', 'a08TaskCount', 'a08PlanTime', 'a08TaskTime', 'a09PlanCount', 'a09TaskCount', 'a09PlanTime', 'a09TaskTime'];
      combinedTypeList.forEach(function (t) {
        number9List[t] = {
          label: _this.$t("sfe.planAndTaskReport.listTable.".concat(t)),
          isCommasNumber: true
        };
      });
      return number9List;
    }
  }
};